module.exports = "/images/flags@2x.png?d429a5777afaf2fc349652e812e9bb11";


//////////////////
// WEBPACK FOOTER
// ./public/img/flags@2x.png
// module id = oUaZ
// module chunks = 5